import 'magnific-popup';

export default () => {
    if (!$.hook('x-magnific-popup').length && !$.hook('x-magnific-popup__ajax').length) return;

    $.hook('x-magnific-popup').magnificPopup();
    $.hook('x-magnific-popup__ajax').magnificPopup({ type: 'ajax' });
};
